import MapboxDraw from '@mapbox/mapbox-gl-draw';
import { LngLat } from 'mapbox-gl';

import { createSupplementaryPointsForCircle } from './modes.helpers';

import type { DrawModeContext } from './types';

type SimpleSelectModeOverrideType = {
  dragMove: (state: any, e: any) => void;
  onBoxSelect: (state: any, e: any) => void;
  onClick: (state: any, e: any) => void;
  onDrag: (state: any, e: any) => void;
  onKeyDown: (state: any, e: any) => void;
  onKeyUp: (state: any, e: any) => void;
  onMapClick: (state: any, e: any) => void;
  onMouseDown: (state: any, e: any) => void;
  onMouseMove: (state: any, e: any) => void;
  onMouseOut: (state: any, e: any) => void;
  onMouseUp: (state: any, e: any) => void;
  onSetup: (opts: any) => any;
  onStop: (state: any) => void;
  onTap: (state: any, e: any) => void;
  onTouchEnd: (state: any, e: any) => void;
  onTouchMove: (state: any, e: any) => void;
  onTouchStart: (state: any, e: any) => void;
  onTrash: (state: any) => void;
  toDisplayFeatures: (state: any, geojson: any, display: (feature: any) => void) => void;
};

const SimpleSelectModeOverride: SimpleSelectModeOverrideType = {
  dragMove: () => {
    // do nothing
  },
  onBoxSelect: () => {
    // do nothing
  },
  onClick: () => {
    // do nothing
  },
  onDrag: () => {
    // do nothing
  },
  onKeyDown: () => {
    // do nothing
  },
  onKeyUp: () => {
    // do nothing
  },
  onMapClick: () => {
    // do nothing
  },
  onMouseDown: () => {
    // do nothing
  },
  onMouseMove: () => {
    // do nothing
  },
  onMouseOut: () => {
    // do nothing
  },
  onMouseUp: () => {
    // do nothing
  },
  onSetup: () => {
    // do nothing
  },
  onStop: () => {
    // do nothing
  },
  onTap: () => {
    // do nothing
  },
  onTouchEnd: () => {
    // do nothing
  },
  onTouchMove: () => {
    // do nothing
  },
  onTouchStart: () => {
    // do nothing
  },
  onTrash: () => {
    // do nothing
  },
  toDisplayFeatures: () => {
    // do nothing
  }
};

Object.assign(SimpleSelectModeOverride, MapboxDraw.modes.simple_select);

SimpleSelectModeOverride.dragMove = function (state: any, e: any) {
  const ctx = this as unknown as DrawModeContext;
  state.dragMoving = true;
  e.originalEvent.stopPropagation();

  const delta = new LngLat(e.lngLat.lng - state.dragMoveLocation.lng, e.lngLat.lat - state.dragMoveLocation.lat);

  MapboxDraw.lib.moveFeatures(ctx.getSelected(), delta);

  ctx
    .getSelected()
    .filter((feature: any) => feature.properties.isCircle)
    .map((circleFeature: any) => circleFeature.properties.center)
    .forEach((center: number[]) => {
      center[0] += delta.lng;
      center[1] += delta.lat;
    });

  state.dragMoveLocation = e.lngLat;
};

SimpleSelectModeOverride.toDisplayFeatures = function (_: any, geojson: any, display: (feature: any) => void) {
  const ctx = this as unknown as DrawModeContext;
  geojson.properties.active = ctx.isSelected(geojson.properties.id)
    ? MapboxDraw.constants.activeStates.ACTIVE
    : MapboxDraw.constants.activeStates.INACTIVE;
  display(geojson);
  ctx.fireActionable();
  if (
    geojson.properties.active !== MapboxDraw.constants.activeStates.ACTIVE ||
    geojson.geometry.type === MapboxDraw.constants.geojsonTypes.POINT
  ) {
    return;
  }
  const supplementaryPoints = geojson.properties.user_isCircle
    ? createSupplementaryPointsForCircle(geojson)
    : MapboxDraw.lib.createSupplementaryPoints(geojson);
  if (supplementaryPoints) {
    supplementaryPoints.forEach(display);
  }
};

export { SimpleSelectModeOverride };
